import React from 'react';
import { Row, Col } from 'antd';

export default () => {
   return (
    <div className="footer">
                <div className="footer-c">
                <Row type="flex" justify="center"  >
                    <Col sm={24} md={21}>
                        <Col sm={24} md={10} className="footer-left">
                            <img className="footer-logo logo-footer" src="https://thicao.com/logo_thicao_grey_2-01-01/" alt="thicao"/>
                            <p>ThiCao - Thiết kế Cao cấp, tiền thân là Dizen Brand Design, đơn vị hàng đầu về Thương hiệu với năng lực sáng tạo cốt lõi và thiết kế đẳng cấp, chuyên nghiệp. 
                                Trụ sở: 10/1194 Đường Láng, Đống Đa, Hà Nội. 
                            </p>
                            <span>ThiCao - Thiết kế Thương hiệu Cao cấp</span><br/>
                            <span>© 2026 thicao.com</span>
                        </Col>
                        <Col sm={0} md={2}></Col>
                        <Col sm={24} md={6} className="footer-tow">
                            <h4>CÔNG CỤ</h4>
                            <p>Đánh giá tên thương hiệu</p>
                            <p>Thiết kế trực tuyến</p>
                            <p>Tư vấn Logo Miễn phí</p>
                            <p>Tư vấn Biển hiệu Miễn phí</p>
                            
                        </Col>
                        <Col sm={24} md={6} className="footer-right">
                            <h4>DỊCH VỤ</h4>
                            <p>Tra cứu sở hữu trí tuệ</p>
                            <p>Thiết kế logo từ ý tưởng của bạn</p>
                            <p>Tinh chỉnh logo từ logo của bạn</p>
                        </Col>
                    </Col>
                </Row>
                </div>
         </div>
   )
}



// WEBPACK FOOTER //
// ./src/components/App/FooterAtBottom.js